import { ExpandLessRounded, ExpandMoreRounded } from "@mui/icons-material";
import { UiBox, UiCollapse, UiTypography } from "@smp/ui";
import { FC, PropsWithChildren, ReactNode, useState } from "react";

import classes from "./filter_group_wrapper.module.css";

export const FilterGroupWrapper: FC<
  PropsWithChildren<{
    icon: ReactNode | undefined;
    title: ReactNode | string;
  }>
> = ({ icon, title, children }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      <UiBox
        className={classes.wrapper}
        onClick={() => setExpanded((state) => !state)}
      >
        <UiBox className={classes.icon}>{icon}</UiBox>

        <UiTypography variant="h5">{title}</UiTypography>
        {expanded ? <ExpandLessRounded /> : <ExpandMoreRounded />}
      </UiBox>

      <UiCollapse in={expanded}>{children}</UiCollapse>
    </>
  );
};
